/* eslint-disable */
import { gsap } from 'gsap';

export class ScrollItem {
  /**
   * @constructor
   * @class ScrollItem
   * @classdesc Creates a ScrollItem to be used for scrolling at different speeds
   *
   * @param {HTMLElement} el
   * @param {Object} options
   *  @param {number} [options.globalSpeed=20] Number of pixels per scroll wheel tick)
   *  @param {number} [options.speed=1] Multiplier per scroll wheel tick
   */
  constructor(el, options = {}) {
    const defaultOptions = {
      globalSpeed: 20,
      speed: 1,
    };

    const clientRect = el.getBoundingClientRect();

    this.options = { ...defaultOptions, ...options };
    this.el = el;
    this.innerHeight = this.el.clientHeight;
    this.rOffset = {};
    this.tOffset = {};
    this.rOffset.top = clientRect.top + window.pageYOffset;
  }

  /**
   * Updates the position of the element
   * @param {number} [duration=0.5] Duration of the updated position in seconds
   */
  update(duration = 0.5) {
    const _this = this;
    const { speed, globalSpeed } = this.options;

    let relTop = +(this.rOffset.top - this.innerHeight / 2 - (window.pageYOffset + window.innerHeight / 2)).toFixed(2);

    this.tOffset.top = +(relTop * speed).toFixed(2) * (globalSpeed / 100);

    gsap.to(_this.el, { y: _this.tOffset.top, duration: duration });
  }

  /**
   * Updates the position and base values of the element during a resize
   */
  resize() {
    const clientRect = this.el.getBoundingClientRect();

    this.rOffset.top = clientRect.top + window.pageYOffset - this.tOffset.top;
    this.innerHeight = this.el.clientHeight;

    this.update();
  }

  /**
   * Resets element back to its original state
   */
  reset() {
    gsap.set(this.el, { y: '' });
    this.tOffset.top = '';
  }
}
